import { ReactNode } from "react";
import designSystemStyles from "@shared/styles/designSystemStyles";

/**
 * Footer for a DS Modal whose content scrolls: stays pinned to the bottom of the
 * modal (e.g. Cancelar / Guardar) while the content moves. Goes as the last child.
 */
export const StickyModalFooter: React.FC<{ children: ReactNode }> = ({ children }) => (
    <div
        style={{
            position: "sticky",
            bottom: 0,
            margin: `0 calc(-1 * ${designSystemStyles.paddingLg}) calc(-1 * ${designSystemStyles.paddingLg})`,
            padding: `${designSystemStyles.paddingMd} ${designSystemStyles.paddingLg}`,
            width: `calc(100% + 2 * ${designSystemStyles.paddingLg})`,
            boxSizing: "border-box",
            background: "var(--color-popup-background)",
            borderTop: `1px solid ${designSystemStyles.colorTextInputBorder}`,
            zIndex: 1,
        }}
    >
        {children}
    </div>
);

export default StickyModalFooter;
